// Grille mensuelle (lundi→vendredi, pas de week-end — l'institution n'est pas
// ouverte samedi/dimanche et aucun atelier n'y a jamais lieu, cf. jour_semaine
// des ateliers 1..5 uniquement) — logique pure, partagée par toutes les vues
// « Calendrier » du Tableau de bord (gestion, Mon calendrier, Demandes des
// collègues). Anciennement dans CalendrierPage.tsx (page autonome supprimée
// — fusionnée dans le Tableau de bord, voir TableauPage.tsx).
export const JOURS_COURTS = ['Lun', 'Mar', 'Mer', 'Jeu', 'Ven'];

export function moisDebut(d: Date): Date { return new Date(d.getFullYear(), d.getMonth(), 1); }
export function moisFin(d: Date): Date { return new Date(d.getFullYear(), d.getMonth() + 1, 0); }
export function iso(d: Date): string { return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`; }

/** Grille de semaines complètes (lundi→vendredi) couvrant le mois donné. */
export function grilleMois(mois: Date): Date[] {
  const debut = moisDebut(mois);
  const fin = moisFin(mois);
  const decalageDebut = (debut.getDay() + 6) % 7; // lundi = 0
  const decalageFin = (7 - ((fin.getDay() + 6) % 7) - 1 + 7) % 7;
  const jours: Date[] = [];
  for (let i = decalageDebut; i > 0; i--) jours.push(new Date(debut.getFullYear(), debut.getMonth(), 1 - i));
  for (let d = 1; d <= fin.getDate(); d++) jours.push(new Date(mois.getFullYear(), mois.getMonth(), d));
  for (let i = 1; i <= decalageFin; i++) jours.push(new Date(fin.getFullYear(), fin.getMonth(), fin.getDate() + i));
  return jours.filter((j) => j.getDay() !== 0 && j.getDay() !== 6); // retire samedi/dimanche
}
